import request from '@/http/request'
import { Base64 } from 'js-base64'

// 登录认证接口
export function login ({ username, password, vercode, vercodeToken }) {
  const data = {
    ia: Base64.encode(username), // 账号
    ip: Base64.encode(password), // 密码
    vc: Base64.encode(vercode), // 验证码值
    vt: Base64.encode(vercodeToken) // 验证码token
  }
  return request.request({
    url: '/api/anon/auth/validate',
    method: 'post',
    data: data
  }, true, true, false)
}
// google验证码登录
export function googleVerify ({ username, password, googleCode }) {
  // console.log('username', username)
  // console.log('password', password)
  // console.log('googleCode', googleCode)
  const data = {
    ia: Base64.encode(username?.trim()), // 账号
    ip: Base64.encode(password?.trim()), // 密码
    cd: Base64.encode(googleCode?.trim()) // 谷歌验证码
  }
  return request.request({ url: '/api/anon/auth/validateByGoogle', method: 'post', data }, true, false, false)
}

// 获取图形验证码信息接口
export function vercode () {
  return request.request({ url: '/api/anon/auth/vercode', method: 'get' }, true, true, true)
}

// 获取当前用户信息
export function getInfo () {
  return request.request({
    url: '/api/current/user',
    method: 'get'
  })
}

// 退出接口
export function logout () {
  return new Promise(resolve => { resolve() })
}

// 校验当前用户谷歌验证码
export const checkGoogleCode = (vercode) => {
  return request.request({
     url: `/api/current/googleAuth/${vercode}`,
     method: 'get'
  })
}

// 基于token登陆跳转
// /api/anon/auth/validate/token
export const getLoginToken = (params) => {
  return request.request({
    url: `/api/anon/auth/validate/token`,
    method: 'get',
    params
  })
}
